import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useBundle } from '@amzn/react-arb-tools';
import Column from '@amzn/meridian/column';
import Text from '@amzn/meridian/text';
import { RetailRoutes, useRetailRedirectUrls } from 'src/utils/links';
import { Link } from 'src/common/styled';
import { ReportActionSource } from '@amzn/handshake-painter-typescript-client/v1';
import { useOffRampToAmazon } from 'src/hooks/useOffRampToAmazon';
export const PaymentSelectionHeader = () => {
    const [bundle, isBundleLoading] = useBundle('pages.paymentSelectionPage');
    const redirectUrls = useRetailRedirectUrls([RetailRoutes.PAYMENT_SELECTION_WALLET]);
    const offRampToAmazon = useOffRampToAmazon();
    const openExternalLink = (e) => {
        e.preventDefault();
        const url = e.currentTarget.href;
        offRampToAmazon(url, ReportActionSource.PaymentSelectionPage);
    };
    if (isBundleLoading)
        return null;
    return (_jsxs(Column, { spacing: "300", spacingInset: "400 350 300 350", children: [_jsx(Text, { type: "h400", children: bundle.getMessage('selectPaymentMethod') }), _jsx(Text, { type: "b100", children: bundle.formatMessage('paymentSelectionWalletRedirect', {
                    AmazonWalletLink: (chunks) => (_jsx(Link, { "data-testid": "amazon-wallet-link", href: redirectUrls.PAYMENT_SELECTION_WALLET, onClick: openExternalLink, children: chunks }, "amazon-wallet-link")),
                }) })] }));
};
